import axios from "axios";

export type CustomerFeatureFlags = Record<string, boolean>;

const FeatureFlagRepo = {
  async getCustomerFlags(customerId: string): Promise<CustomerFeatureFlags> {
    const uri = `${import.meta.env.VITE_API_URL}/flags/customers/${customerId}`;
    const { data } = await axios.get(uri);

    const raw: Record<string, boolean | null | undefined> = data?.flags ?? data?.Flags ?? {};
    // Necessary?
    const normalized: CustomerFeatureFlags = {};
    for (const [key, value] of Object.entries(raw)) {
      normalized[key] = value === true;
    }
    return normalized;
  },
};

export default FeatureFlagRepo;
